import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { isSubCategoryMandatory } from 'partner360/entities/planning'

import { IClientSectionSettings } from '../../../../../../features/partner360/sectionSettings/models/iSectionSettingsState'
import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { OVERALL_CATEGORY } from '../config'

import { getMandatoryLinesInCategoryCount } from './partnerFlags/getMandatoryLinesInCategoryCount'

export const getSubCategoriesWithPlanCount = (
  items: IJBPPlanningItem[],
  formats: IFormActualsTargetsSettings[],
  settingsIndex: number,
  fy: number,
  fq: number,
  isContr: boolean,
  isMandatoryByFlagLogic: boolean,
  partnerFlags: string,
  sectionSettings: Partial<IClientSectionSettings>
): number => {
  return isMandatoryByFlagLogic
    ? getSubCategoriesWithPlanCountWithFlagLogic(
        items,
        formats,
        settingsIndex,
        fy,
        fq,
        isContr,
        partnerFlags,
        sectionSettings
      )
    : getSubCategoriesWithPlanCountWithPreviousLogic(items, formats, settingsIndex, fy, fq, isContr)
}

const getSubCategoriesWithPlanCountWithPreviousLogic = (
  items: IJBPPlanningItem[],
  formats: IFormActualsTargetsSettings[],
  settingsIndex: number,
  fy: number,
  fq: number,
  isContr: boolean
): number => {
  let result = 0

  if (settingsIndex < formats.length) {
    const setting = formats[settingsIndex]

    // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
    // All SubCategories data without Overall, L3
    const sourceData = items.filter(
      (el) =>
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        el.SubCategory !== OVERALL_CATEGORY &&
        (!el.L3Category || el.L3Category === OVERALL_CATEGORY) &&
        el.FYear === fy &&
        el.FQuarter === fq
    )
    sourceData.forEach((el) => {
      const isNoPlanField = isContr ? 'IsNoPlanContractual' : 'IsNoPlan'
      const isNoPlanValue = Boolean(el[isNoPlanField])
      if (!isNoPlanValue) {
        result++
      }
    })
  }

  return result
}

const getSubCategoriesWithPlanCountWithFlagLogic = (
  items: IJBPPlanningItem[],
  formats: IFormActualsTargetsSettings[],
  settingsIndex: number,
  fy: number,
  fq: number,
  isContr: boolean,
  partnerFlags: string,
  sectionSettings: Partial<IClientSectionSettings>
): number => {
  let result = 0

  if (settingsIndex < formats.length) {
    const currentSetting = formats[settingsIndex]

    const curProgramType = currentSetting.ProgramType
    const curCat = currentSetting.Category
    const curSubCat = currentSetting.SubCategory
    const curL3Cat = currentSetting.L3Category
    const curIsL3Overall = curL3Cat === OVERALL_CATEGORY
    const curIsL3 = !!curL3Cat
    const curIsL3Child = curIsL3 && !curIsL3Overall

    formats
      // Category filter
      .filter((el) => el.ProgramType === curProgramType && el.Category === curCat)
      // L2, L3 Overall / L3 filter
      .filter(
        (el) =>
          (!curIsL3Child &&
            el.SubCategory !== OVERALL_CATEGORY &&
            !!el.SubCategory &&
            (!el.L3Category || el.L3Category === OVERALL_CATEGORY)) ||
          (curIsL3Child &&
            el.SubCategory === curSubCat &&
            el.L3Category !== OVERALL_CATEGORY &&
            !!el.L3Category)
      )
      .forEach((setting) => {
        const isMandatoryByFlag = isSubCategoryMandatory(
          partnerFlags,
          setting.MandatoryByFlags,
          sectionSettings,
          true
        )
        const isMandatoryByFlagUnits = isSubCategoryMandatory(
          partnerFlags,
          setting.UnitsMandatoryByFlags,
          sectionSettings,
          true
        )

        const l3Cat = setting.L3Category
        const isL3Overall = l3Cat === OVERALL_CATEGORY
        const isL3 = !!l3Cat
        const isL3Child = isL3 && !isL3Overall

        // Get Count of Mandatory inside this L3 tree
        let mandatoryInChildCount = 0
        if (isL3Overall) {
          mandatoryInChildCount = getMandatoryLinesInCategoryCount({
            partnerFlags,
            formats,
            currentFormat: setting,
            sectionSettings,
            isUnits: false,
            restrictL3Child: setting.SubCategory,
          })
        }

        if (
          (!isL3 || isL3Child || !mandatoryInChildCount) &&
          (isMandatoryByFlag.isMandatory || isMandatoryByFlagUnits.isMandatory)
        ) {
          // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
          // Overview only data for current SubCategory without Overall, L3
          const sourceData = items.filter(
            (el) =>
              el.ProgramTypes === setting.ProgramType &&
              el.Category === setting.Category &&
              el.SubCategory === setting.SubCategory &&
              el.L3Category === setting.L3Category &&
              el.FYear === fy &&
              el.FQuarter === fq
          )
          sourceData.forEach((el) => {
            const isNoPlanField = isContr ? 'IsNoPlanContractual' : 'IsNoPlan'
            const isNoPlanValue = Boolean(el[isNoPlanField])
            if (!isNoPlanValue) {
              result++
            }
          })
        }
      })
  }

  return result
}
